

























































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import VaultInjectorMixin from "@/mixins/vaultInjectorMixin";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

@Component
export default class VaultNoteForm extends Mixins(
  VaultInjectorMixin,
  HasValidation,
  Context
) {
  // Props

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isProcessing = false;
  public form = this.initForm();
  public uuid = "";

  // Methods

  public clearSecret() {
    this.form = this.initForm();
    this.uuid = this.$uuid();
  }

  public initForm() {
    return {
      note: "",
      label: "",
      visible_for_client: true
    };
  }

  public async validateBeforeSubmit() {
    if (this.isDisabled || !this.vaultData.canCreate) return;

    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.isProcessing = true;

      await this.$vaultMethods.createVaultAsset({
        encrypted: true,
        pinned: false,
        visible_for_client: true,
        label: this.form.label,
        note: this.form.note,
        contract_product_id: this.vaultData.contractProductId
      });
      await this.$vaultMethods.refreshData();
      this.clearSecret();
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.successfully_saved")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get formIsDisabled() {
    return (
      this.isDisabled || this.hasErrors || !this.form.note || !this.form.label
    );
  }

  public get submitIsEnabled() {
    return !!this.form.note || !!this.form.label;
  }
}
